import { notification } from 'antd'
// import store from 'store'

import { restClientNoToken as restClient } from 'myNet'

export default restClient

// const validateOTPURL = '/v1/auth/validate/otp'
const sendEmailURL = '/v1/auth/send/otp'
const loginURL = '/v1/auth/login/otp'

// export async function validateOTP() {
//   return restClient
//     .get(validateOTPURL)
//     .then((response) => {
//       console.log('res = ', response)
//       return response
//     })
//     .catch((error) => {
//       notification.warning({
//         message: error.code,
//         description: error.message,
//       })
//     })
// }

export async function reqOtpCode(email) {
  return restClient
    .post(sendEmailURL, { email })
    .then((res) => {
      if (process.env.REACT_APP_TARGET.indexOf('test') > -1) {
        if (res.data.otp != null) {
          // const log = getLogger({ name: 'NextIntelligence' })
          console.log(`OTP CODE : ${res.data.otp}`)
        }
      }
      return {
        success: true,
        otp_expires_in: res.data.otp_expires_in,
      }
    })
    .catch((error) => {
      notification.warning({
        message: error.code,
        description: error.message,
      })
    })
}

export async function verifyOtpCode(email, loginCode) {
  return restClient.post(loginURL, { email, otp: loginCode })
}
